import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import TrackedItemsInPredesReport from '../components/TrackedItemsInPredesReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/TrackedItemsInPredesSummarySelectors';
import ReportCustomFilterTypes from '../../../../common/redux/actions/types/ReportCustomFilterTypes';

export function TrackedItemsInPredesSummaryContainer(props) {
  return (
    <TrackedItemsInPredesReport
      reportId={ReportDefinitions.TRACKED_ITEMS_IN_PREDES_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
      customFilterType={ReportCustomFilterTypes.TRACKED_ITEMS_IN_PREDES}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

TrackedItemsInPredesSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(TrackedItemsInPredesSummaryContainer);
